import React from 'react';
import clsx from 'clsx';
import { MTextBlockSimple } from '../../molecules/MTextBlockSimple/index';
import { MButton } from '../../molecules/MButton/index';
import { MMediaSelector } from '../../molecules/MMediaSelector/index';
import type { OCardFeatureProps } from './OCardFeature.types';
import * as Styled from './OCardFeature.styles';
import { AHeaderSize, AHeaderTag } from '../../atoms/AHeader';

const COMPONENT_NAME = 'o-mi-web-ui-kit-OCardFeature';
const TEST_ID = 'mi-web-ui-kit-OCardFeature';

export const OCardFeature: React.FC<OCardFeatureProps> = ({
  contentAlignment = 'Left',
  layout = 'Default',
  mTextBlockSimple,
  mButton,
  mButton2,
  mMediaSelector,
  className,
  trackingProperties,
  ...rest
}) => {
  const showButton1 = Boolean(mButton?.buttonText);
  const showButton2 = Boolean(mButton2?.buttonText);

  const { aBody = {}, aEyebrow = {}, aHeader = {} } = mTextBlockSimple ?? {};

  const modifiedMTextBlockSimple = {
    bodyText: aBody.bodyText ?? '',
    eyebrowText: aEyebrow.eyebrowText ?? '',
    headerText: aHeader.text ?? '',
    headerSize: aHeader.size as AHeaderSize,
    headerTag: aHeader.headerTag as AHeaderTag,
  };

  return (
    <Styled.CardFeatureWrapper
      className={clsx(className, 'o-card-feature')}
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      $contentAlignment={contentAlignment}
      $layout={layout}
      {...rest}
    >
      <Styled.MediaContainer $layout={layout}>
        {mMediaSelector && <MMediaSelector {...mMediaSelector} className="o-card-feature__media" />}
      </Styled.MediaContainer>

      <Styled.ContentContainer $contentAlignment={contentAlignment} $layout={layout}>
        {mTextBlockSimple && (
          <Styled.TextBlockWrapper className="o-card-feature__text-block">
            <MTextBlockSimple {...modifiedMTextBlockSimple} />
          </Styled.TextBlockWrapper>
        )}

        {(showButton1 || showButton2) && (
          <Styled.ButtonGroup $contentAlignment={contentAlignment}>
            {showButton1 && (
              <Styled.ButtonWrapper>
                <MButton
                  {...mButton}
                  className="o-card-feature__button-primary"
                  trackingProperties={{
                    ...trackingProperties,
                    ...mButton?.trackingProperties,
                  }}
                />
              </Styled.ButtonWrapper>
            )}
            {showButton2 && (
              <Styled.ButtonWrapper>
                <MButton
                  {...mButton2}
                  className="o-card-feature__button-secondary"
                  trackingProperties={{
                    ...trackingProperties,
                    ...mButton2?.trackingProperties,
                  }}
                />
              </Styled.ButtonWrapper>
            )}
          </Styled.ButtonGroup>
        )}
      </Styled.ContentContainer>
    </Styled.CardFeatureWrapper>
  );
};
